import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Translation } from 'react-i18next';

import { connect } from "react-redux";
import {
  fetchCatalogDescription,
  clearPatchCatalogDescription,
} from 'redux/catalog/actions';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import CatalogName from 'components/dashboard/catalog-content/CatalogName';
import CatalogUrl from 'components/dashboard/catalog-content/CatalogUrl';
import CatalogButtonStyleSelector
  from 'components/dashboard/catalog-content/CatalogButtonStyleSelector';

import './CatalogDescription.css';

class CatalogDescription extends Component {
  static propTypes = {
    fetchCatalogDescription: PropTypes.func.isRequired,
    clearPatchCatalogDescription: PropTypes.func.isRequired,
    catalogDescription: PropTypes.object,
    patchCatalogDescriptionSuccess: PropTypes.object,
    patchCatalogDescriptionError: PropTypes.object,
  };

  static defaultProps = {
    catalogDescription: null,
    patchCatalogDescriptionSuccess: null,
    patchCatalogDescriptionError: null,
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.patchCatalogDescriptionSuccess &&
      this.props.patchCatalogDescriptionSuccess
    ) {
      this.props.fetchCatalogDescription();
      this.props.clearPatchCatalogDescription();
    }
  }

  render() {
    if (!this.props.catalogDescription) {
      return null;
    };

    return (
      <Translation>
        {(t) => (
          <DashboardFormSection header={t("STORE SETTINGS")}>
            <div className="catalog-description__component">
              <div className="catalog-settings">
                {/* Store Name */}
                <div className="section">
                  <CatalogName />
                </div>

                {/* Store URL */}
                <div className="section">
                  <CatalogUrl />
                </div>

                {/* Store Button Background Color */}
                <div className="section">
                  <CatalogButtonStyleSelector
                    key="store-button-background-color-picker-key"
                    pickerId="store-button-background-color-picker-id"
                    label={t("Store Button Background Color")}
                    defaultColor="#E66756"
                    parameter='button_color'
                  />
                </div>

                {/* Store Button Font Color */}
                <div className="section">
                  <CatalogButtonStyleSelector
                    key="store-button-font-color-picker-key"
                    pickerId="store-button-font-color-picker-id"
                    label={t("Store Button Font Color")}
                    defaultColor="#FFFFFF"
                    parameter='button_font_color'
                  />
                </div>
              </div>

            </div>
          </DashboardFormSection>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    catalogDescription: state.catalogReducer.catalogDescription,
    patchCatalogDescriptionSuccess: state.catalogReducer.patchCatalogDescriptionSuccess,
    patchCatalogDescriptionError: state.catalogReducer.patchCatalogDescriptionError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCatalogDescription,
    clearPatchCatalogDescription,
  },
)(CatalogDescription);
